import { render, staticRenderFns } from "./AudioList.vue?vue&type=template&id=b67ddd92&scoped=true&"
import script from "./AudioList.vue?vue&type=script&lang=js&"
export * from "./AudioList.vue?vue&type=script&lang=js&"
import style0 from "./AudioList.vue?vue&type=style&index=0&id=b67ddd92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67ddd92",
  null
  
)

export default component.exports